import { render } from "./afterSales.vue?vue&type=template&id=0f1375aa&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=0f1375aa&scoped=true&lang=css"
import "./afterSales.vue?vue&type=style&index=1&id=0f1375aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f1375aa"

export default script